import React from 'react';
import { FiGrid, FiStar } from 'react-icons/fi';

const VIEW_OPTIONS = {
  grid: { label: 'Cuadricula', icon: FiGrid },
  slots: { label: 'Favs', icon: FiStar },
};

const ProductViewToggle = ({ value, onChange, allowedViews = ['grid'] }) => (
  <div className="flex" onClick={(event) => event.stopPropagation()}>
    <div className="inline-flex rounded-lg border border-gray-200 bg-white shadow-sm p-1">
      {allowedViews
        .map((view) => ({ ...VIEW_OPTIONS[view], value: view }))
        .filter((option) => option.label && option.icon)
        .map((option) => {
          const Icon = option.icon;
          const isActive = value === option.value;
          return (
            <button
              key={option.value}
              type="button"
              onClick={() => onChange(option.value)}
              className={`flex items-center gap-2 px-3 py-1.5 rounded-md text-xs sm:text-sm font-semibold transition-colors ${
                isActive ? 'bg-blue-500 text-white' : 'text-gray-600 hover:text-gray-900'
              }`}
              aria-pressed={isActive}
            >
              <Icon size={14} />
              {option.label}
            </button>
          );
        })}
    </div>
  </div>
);

export default ProductViewToggle;
